import React from 'react';

import type { RouteProps } from 'react-router-dom';
import { Redirect, Route } from 'react-router-dom';

import GlobalLoader from 'common/components/GlobalLoader/GlobalLoader';
import usePermissions from 'common/components/withPermissions/usePermissions';
import type Permissions from 'common/constants/permissions';

type RestrictedRouteProps = RouteProps & {
  permissions: Permissions | Permissions[];
};

export default function RestrictedRoute({ component: Component, permissions, ...routeProps }: RestrictedRouteProps) {
  const permissionNames = Array.isArray(permissions) ? permissions : [permissions];
  const { loading, hasSomeOf } = usePermissions({ permissionNames });

  return (
    <Route
      {...routeProps}
      render={props => {
        if (loading) {
          return <GlobalLoader />;
        }

        if (!hasSomeOf(permissionNames)) {
          return <Redirect to="/" />;
        }

        return Component ? <Component {...props} /> : null;
      }}
    />
  );
}
